import moment from "moment";

export const hasValidExpiryDate = (date) => {
  const getMonth = new Date().getMonth();
  const getYear = new Date().getFullYear();
  const currentDate = `${getMonth + 1}/${getYear}`;

  const enteredDateInMoment = moment.utc(date, "MM/YYYY");
  const currentDateInMoment = moment.utc(currentDate, "MM/YYYY");

  if (enteredDateInMoment.isAfter(currentDateInMoment)) {
    return true;
  } else return false;
};
